<template>
    <div class="tw-flex-col tw--mx-3">
		<div class="px-3 tw-pb-3">
			<c-title-header
				:title="selectedJob.name"
				@go-to-back="goTo(codeStep.returnTo)"></c-title-header>
		</div>
		<div class="tw-flex">
			<div class="px-3 tw-w-3/5">
				<model-stepper
					:current-step="6"
					class="tw-mb-4"
					@code-step="loadCodeStep">
				</model-stepper>
				<p-card class="tw-flex-auto tw-flex tw-flex-col tw-justify-between tw-my-">
					<div class="tw-flex tw-justify-between tw-items-center tw-mb-1">
						<p class="tw-text-app-color-primary text-lg">
							Seleccione el nivel de relevancia correspondiente a cada responsabilidad
						</p>
					</div>
					<section class="responsability">
						<table>
							<tr>
								<th class="titles-table">RESPONSABILIDAD</th>
								<th colspan="3">
									<tr style="width: 100%;">
										<th colspan="3" class="titles-table">RELEVANCIA</th>
									</tr>
									<tr>
										<template v-for="(rel, index) in relevance" >
											<th
												class="rel-item"
												:key="index">{{ rel.name }}</th>
										</template>
									</tr>
								</th>
							</tr>
							<tr v-if="alternatingFlow" v-for="(responsa, rowIndex) in selectedChecks" :key="rowIndex">
								<th class="list-res">
									<div class="cell-content">
										<span>{{ responsa.name }}</span> 
										<app-tooltip-button
											class="icon"
											size="18"
											:text="responsa.description"
											img="/static/img/info.svg"
											disabled
										></app-tooltip-button>
									</div>
								</th>
								<td class="check" v-for="(check, colIndex) in responsa.checks" :key="colIndex">
									<v-checkbox
										hide-details
										color="success"
										style="background: white"
										class="custom-checkbox"
										:value="check"
										@change="selectedCheck(rowIndex, colIndex)"
									>
									</v-checkbox>
								</td>
							</tr>
							<tr v-if="!alternatingFlow" v-for="(responsab, rowIndexF) in selectedChecks" :key="rowIndexF">
								<th class="list-res">
									<div class="cell-content">
										<span>{{ responsab.name }}</span> 
										<app-tooltip-button
											class="icon"
											size="18"
											:text="responsab.description"
											img="/static/img/info.svg"
											disabled
										></app-tooltip-button>
									</div>
								</th>
								<td class="check" v-for="(checkF, columnIndex) in responsab.checks" :key="columnIndex">
									<v-checkbox
										hide-details
										color="success"
										style="background: white"
										class="custom-checkbox"
										v-model="responsab.checks[columnIndex]"
										@change="selectedCheck(rowIndexF, columnIndex)"
									>
									</v-checkbox>
								</td>
							</tr>
						</table>
						<div>
							<p-horizontal-divider />
							<div class="tw-text-center">
								<p-button
									type="primary"
									@click="goTo(codeStep.returnTo)"
								>
									Atrás
								</p-button>
								<p-button
									type="secondary"
									:disabled="validationEmptyData"
									@click="saveStepResponsability"
								>
									Siguiente
								</p-button>
							</div>
						</div>
					</section>
				</p-card>
			</div>
			<div class="px-3 tw-w-2/5">
				<model-description
					:title="'RESPONDABILIDADES DEL PUESTO'"
					:subtitle="'INSTRUCCIONES'">
					<div class="tw-my-4" slot="content">
						<p style="font-size: 13px;" class="tw-text-center">Seleccione los apartados mas importantes al momento 
							de definir el puesto.
						</p>
						<div class="tw-flex tw-flex-col tw-items-center">
							<br>
							<p-button
								class="tw-my-4"
								type="primary"
							>
								Mira nuestro tutorial paso a paso
							</p-button>
						</div>
					</div>
				</model-description>
			</div>
		</div>
    </div>
</template>

<script>
import cTitleHeader from '@/modules/job-profile/components/content/c-title-header';
import modelStepper from '@/modules/job-profile/components/content/model-stepper';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import PEmptyMessage from '@/modules/shared/components/ui/p-empty-message';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import modelDescription from '@/modules/job-profile/components/content/model-description';
import helper from '@/shared/helper';
import { mapState } from 'vuex';
import { pathOr, pipe, map, assoc } from 'ramda';

const { getLocalData } = helper;

async function loadData() {
	try {
		if (this.codeStep) {
			const { data: response } = await this.$httpPraktiko.get(`job-description/detail/${this.codeStep.code}/${this.selectedJob.id}`);
			if (Object.keys(response).length !== 0) {
				this.selectedChecks = response.description;
				this.selectedChecks = this.selectedChecks.map((lr) => {
					const matchingResponsability = this.responsability.find(res => res.id === lr.id);
					if (matchingResponsability) {
						return {
							...lr,
							description: matchingResponsability.description,
						};
					}
					return lr;
				});
				this.validationEmptyData = this.selectedChecks.some(obj => obj.checks
					.every(check => check === false));
				this.alternatingFlow = false;
			} else {
				this.selectedChecks = this.responsability;
				this.alternatingFlow = true;
				this.validationEmptyData = this.selectedChecks.some(obj => obj.checks
					.every(check => check === false));
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function loadCodeStep(obj) {
	this.codeStep = obj;
}

function selectedCheck(rowIndex, columnIndex) {
	if (!this.alternatingFlow) {
		this.selectedChecks[rowIndex].checks.forEach((check, index) => {
			if (index !== columnIndex) {
				this.selectedChecks[rowIndex].checks[index] = false;
			}
		});
		this.selectedChecks[rowIndex].selectedIndex = columnIndex;
	} else if (this.alternatingFlow) {
		const row = this.selectedChecks[rowIndex];
		if (row.checks[columnIndex]) {
			this.$set(row.checks, columnIndex, false);
		} else {
			row.checks = row.checks.map((_, index) => index === columnIndex);
		}
		this.$forceUpdate();
		this.validationEmptyData = this.selectedChecks.some(obj => obj.checks
			.every(check => check === false));
	}
	this.validationEmptyData = this.selectedChecks.some(obj => obj.checks
		.every(check => check === false));
}

function cloneCheckArray(checks) {
	return checks.slice();
}

async function saveStepResponsability() {
	this.selectedChecks = this.selectedChecks.map((f) => {
		const newF = {
			id: f.id,
			checks: f.checks,
			name: f.name,
			code: f.code,
			selectedIndex: f.selectedIndex,
			description: f.description,
		};
		return newF;
	});
	const body = {
		description: this.selectedChecks,
		typeDescriptionCode: this.codeStep.code,
		jobId: this.selectedJob.id,
	};
	try {
		await this.$httpPraktiko.post('job-description', body);
		this.showNotification('Compromisos Medibles Guardados Exitosamente');
		this.goTo(this.codeStep.goTo);
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		codeStep: {},
		selectedChecks: [],
		validationEmptyData: true,
		alternatingFlow: false,
	};
}

export default {
	name: 'job-measurable-commitments',
	data,
	beforeMount() {
		this.$store.dispatch('jobProfile/loadResponsabilities');
		this.$store.dispatch('jobProfile/loadRelevance');
	},
	mounted() {
	},
	components: {
		cTitleHeader,
		modelStepper,
		PCard,
		PEmptyMessage,
		PButton,
		PHorizontalDivider,
		modelDescription,
	},
	methods: {
		loadData,
		loadCodeStep,
		saveStepResponsability,
		selectedCheck,
		cloneCheckArray,
	},
	computed: {
		...mapState('jobProfile', {
			selectedJob(state) {
				return pathOr(getLocalData('selectedJob'), ['selectedJob'], state.jobProfile) || [];
			},
			responsability: pipe(
				pathOr([], ['descriptionData', 'responsabilities']),
				map(assoc('checks', [false, false, false])),
				map(assoc('selectedIndex', null)),
			),
			relevance: pathOr([], ['descriptionData', 'relevance']),
		}),
	},
	watch: {
		codeStep: {
			handler(newVal) {
				this.codeStep = newVal;
				this.loadData();
			},
		},
	},
};

</script>

<style lang="scss" scoped>
.responsability {
	width: 100%;
	table {
		width: 100%;
		.titles-table {
			background-color: color(green-dark);
			color: color(white);
			border-radius: 4px;
			padding: 2px 0;
			font-weight: font(bold);
		}
		.rel-item {
			min-width: 100px !important;
			background-color: color(orange-light);
			color: color(white);
			border-radius: 4px;
			padding: 2px 0;
			font-weight: font(bold);
		}
		.list-res {
			width: 60% !important;
			background-color: color(orange-light);
			color: color(white);
			border-radius: 4px;
			padding: 5px 0;
			font-weight: font(bold);
			position: relative;
		}
		.cell-content {
			display: flex;
			justify-content: center;
		}
		.icon {
			position: absolute;
			right: 0;
			bottom: 0;
		}
		.check {
			padding-left: 40px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/job-profile/pages/commitments-page/job-measurable-commitments.vue